export class userDetails {
    UserId: number;
    EmailId: string;
    UserName: string;
    RoleId: number;
    RoleName: string;
    ClientId: number;
    token: string;
    Name?: string;
}